import { FormikErrors, FormikTouched } from 'formik';
import React from 'react';
import ISendReceipt from '../../interfaces/sendReceipt/sendReceiptMultistep';
import { useMultiStepFormContext } from './context/multistepContext';
import { FormStepHeading, FormStepWrapper } from './sendReceiptMultistep.styles';

const isFieldNotTouchedOrErrorFree = <T extends object>(
	field: keyof T,
	touched: FormikTouched<T>,
	errors: FormikErrors<T>
): boolean => {
	return !touched[field] || !errors[field];
};

export const isStepStateValid = (
	stepIndex: number,
	touched: FormikTouched<ISendReceipt>,
	errors: FormikErrors<ISendReceipt>
) => {
	switch (stepIndex) {
		case 0:
			return isFieldNotTouchedOrErrorFree('trackingNumbers', touched, errors);
		case 1:
			return (
				isFieldNotTouchedOrErrorFree('name', touched, errors) &&
				isFieldNotTouchedOrErrorFree('phone', touched, errors) &&
				isFieldNotTouchedOrErrorFree('email', touched, errors) &&
				isFieldNotTouchedOrErrorFree('identificationNumber', touched, errors)
			);
		case 2:
			return isFieldNotTouchedOrErrorFree('instructionsToStaff', touched, errors);
		case 3:
			return (
				isFieldNotTouchedOrErrorFree('hasReceipt', touched, errors) &&
				isFieldNotTouchedOrErrorFree('files', touched, errors) &&
				isFieldNotTouchedOrErrorFree('additionalInformation', touched, errors) &&
				isFieldNotTouchedOrErrorFree('clearedTrackingNumber', touched, errors) &&
				isFieldNotTouchedOrErrorFree('giftType', touched, errors)
			);
		case 4:
			return isFieldNotTouchedOrErrorFree('deliveryService', touched, errors);
		default:
			return true;
	}
};

export default function InactiveStep({
	heading,
	onClick,
	touched,
	errors,
}: {
	heading: string;
	onClick: () => void;
	touched: FormikTouched<ISendReceipt>;
	errors: FormikErrors<ISendReceipt>;
}) {
	const { currentStepIndex } = useMultiStepFormContext();
	const shouldAllowOnclick = isStepStateValid(currentStepIndex, touched, errors);

	const handleOnclick = () => {
		if (shouldAllowOnclick) {
			onClick();
		}
	};

	return (
		<FormStepWrapper onClick={handleOnclick}>
			<FormStepHeading inactive>{heading}</FormStepHeading>
		</FormStepWrapper>
	);
}
